import { render } from "./InfoTable.vue?vue&type=template&id=6ceaf168&ts=true"
import script from "./InfoTable.vue?vue&type=script&lang=ts"
export * from "./InfoTable.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__